import { TimelineMax } from "gsap/all";
// require('scrollmagic/scrollmagic/uncompressed/plugins/animation.gsap');

export function popUpTimeline() {
	let popUp = new TimelineMax();
	popUp
		.to($('.popup'), 0.5, { yPercent: -100 })
		.to($('.footer-container .bottomTiles'), 0.5, { top: -89 }, '-=0.5')
		.to($('.footer-container .logoContent'), 0.5, { marginBottom: '89px' }, '-=0.5')
	;
	return popUp;
};

export function popUpCloseTimeline() {
	let popUpClose = new TimelineMax({ paused: true });
	popUpClose
		.to($('.popup'), 0.5, { yPercent: 100 })
		.to($('.footer-container .bottomTiles'), 0.5, { top: 0 }, '-=0.5')
		.to($('.footer-container .logoContent'), 0.5, { marginBottom: '0px' }, '-=0.5')
	;
	return popUpClose;
};
